import { WarningCaptionController } from './warning-caption.controller'

function warningCaption () {
  return {
    restrict: 'E',
    scope: {
      text: '@',
      url: '@',
      icon: '@',
      backgroundColor: '@'
    },
    templateUrl: '/core/directives/warning-caption/warning-caption.html?$$REVISION$$',
    controller: WarningCaptionController
  }
}

export { warningCaption }
